// components
import GridPageAbstract from '../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';
import { GATEWAY_API_KIND } from '../../constants/gatewayApiKind';

export default class GatewayApisPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'publicGatewayApis';
        this.Server = this.props.context.getState().server.publicGatewayApis;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['name'];

        const defaultHead = [
            // The name is the key core finds the driver by, so it cannot change
            // while settings use the API (TRIGGER_GATEWAY_API_IN_USE).
            { id: 'name', required: true, label: 'name', alignRight: false, cell: 'Text', displayGrid: true },
            // The kinds of gateway settings this API may back. Only kinds core has
            // a driver of are taken (GATEWAY_API_KIND_UNSUPPORTED), and one still
            // used by settings cannot leave. type 'tags': a new row starts with
            // none rather than null.
            {
                id: 'kinds',
                label: 'kinds',
                alignRight: false,
                cell: 'StaticMultiSelect',
                type: 'tags',
                items: GATEWAY_API_KIND,
                maxTags: GATEWAY_API_KIND.length,
                helperText: 'gatewayApiKinds',
                displayGrid: true
            },
            {
                id: 'bankId',
                label: 'bank',
                alignRight: false,
                cell: 'Select',
                from: 'publicBanks',
                object: 'bank',
                show: 'name',
                displayGrid: true
            },
            { id: 'isArchived', label: 'isArchived', alignRight: false, cell: 'Boolean', displayGrid: true },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName'
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
